<template>
  <section
    id="location"
    v-if="hasMapOrLink || (viewer?.is_owner && ownerViewMode)"
    class="border-t border-charcoal-blue"
    aria-label="Map"
  >
    <div class="max-w-[1400px] mx-auto border-x border-charcoal-blue">
      <div
        v-if="hasMapOrLink"
        class="w-full h-[320px] md:h-[500px] flex flex-col items-center justify-center bg-concrete-gray relative overflow-hidden"
      >
        <div class="absolute inset-0 opacity-10 pointer-events-none bg-[length:40px_40px]" style="background-image: linear-gradient(#1e293b 1px, transparent 1px), linear-gradient(90deg, #1e293b 1px, transparent 1px);" aria-hidden="true" />
        <div class="relative z-10 w-full h-full min-h-0">
          <PublicRestaurantMap
            :restaurant="restaurant"
            :show-owner-map-hint="viewer?.is_owner === true"
            container-class="h-[320px] md:h-[500px] w-full border border-charcoal-blue rounded-none"
            link-class="bg-oxidized-copper text-white hover:bg-charcoal-blue border-2 border-charcoal-blue focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-charcoal-blue"
          />
        </div>
      </div>
      <div
        v-else-if="viewer?.is_owner && ownerViewMode"
        class="w-full py-8 px-6 flex flex-col items-center justify-center"
      >
        <div class="py-4 px-4 rounded border border-dashed border-charcoal-blue/40 bg-charcoal-blue/5 max-w-md">
          <p class="text-sm font-mono text-charcoal-blue/70">{{ $t('public.noMapSetOwnerMessage') }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'
import PublicRestaurantMap from '@/components/public/PublicRestaurantMap.vue'
import { restaurantHasMapOrLink } from '@/utils/googleMapsUrl'

const props = defineProps({
  restaurant: { type: Object, default: () => ({}) },
  viewer: { type: Object, default: () => ({ is_owner: false }) },
  ownerViewMode: { type: Boolean, default: true },
})

const hasMapOrLink = computed(() => restaurantHasMapOrLink(props.restaurant))
</script>
